import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Cargo1 from "../images/cargo1.jpg";
import Cargo2 from "../images/cargo2.jpg";
import Cargo3 from "../images/cargo3.jpg";
import Cargo4 from "../images/cargo4.jpg";

const images = [Cargo1, Cargo2, Cargo3, Cargo4];

const AboutHero = () => {
  const [current, setCurrent] = useState(0);

  // Auto-slide every 4 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-emerald-50 via-white to-indigo-50">
      {/* Blurry Gradient Background */}
      <div className="absolute inset-0">
        <div
          className="absolute top-0 left-0 w-96 h-96 bg-emerald-200/40 rounded-full blur-3xl"
          style={{ transform: "translate(-30%, -20%)" }}
        />
        <div
          className="absolute bottom-0 right-0 w-[28rem] h-[28rem] bg-indigo-200/40 rounded-full blur-3xl"
          style={{ transform: "translate(30%, 20%)" }}
        />
      </div>

      {/* Content Container */}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-28 md:py-40 grid md:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="space-y-6"
        >
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight">
            Innovating Software for{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-500 to-indigo-600">
              Shipping, Logistics & Beyond
            </span>
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed max-w-xl">
            With over <strong>15 years of domain expertise</strong>,{" "}
            <span className="font-semibold text-gray-800">
              Quadrangle Solutions
            </span>{" "}
            delivers robust, scalable, and customized software solutions. <br />
            Our{" "}
            <span className="text-emerald-600 font-semibold">
              AI-powered platforms
            </span>{" "}
            empower businesses to optimize operations, reduce costs, and unlock
            new efficiencies across the global logistics ecosystem—and beyond.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 pt-4">
            <a
              href="/services-product"
              className="px-6 py-3 text-white bg-gradient-to-r from-emerald-600 to-indigo-600 rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition duration-300 font-medium"
            >
              Explore Our Solutions
            </a>
            <a
              href="/contact"
              className="px-6 py-3 rounded-full border border-gray-300 text-gray-800 hover:border-emerald-400 hover:text-emerald-600 transition duration-300 font-medium"
            >
              Contact Us
            </a>
          </div>
        </motion.div>

        {/* Right Illustration - Slider */}
        <motion.div
          initial={{ opacity: 0, x: 60 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9 }}
          className="relative flex justify-center"
        >
          <div className="relative w-full max-w-md h-[350px] overflow-hidden rounded-2xl shadow-2xl">
            <AnimatePresence mode="wait">
              <motion.img
                key={current}
                src={images[current]}
                alt={`Cargo ${current + 1}`}
                className="absolute inset-0 w-full h-full object-cover"
                initial={{ opacity: 0, scale: 1.1 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.8 }}
              />
            </AnimatePresence>
          </div>

          {/* Dots Navigation */}
          <div className="absolute bottom-3 flex space-x-2">
            {images.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrent(idx)}
                className={`w-3 h-3 rounded-full ${
                  idx === current ? "bg-emerald-500" : "bg-gray-300"
                }`}
              />
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutHero;
